import { DirectionEnum } from "../../../../../../shared/models/directions-enum";

export class MergeImageRequestModel {
  images  : File[]=[];
  orientation :string= DirectionEnum.Horizontal;
}

export class MergeImageResponseModel {
  base64_image!:string;
  content_type!:string;
}




